import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { fontWeights } from "et3-ui-library";
import i18n, { Ti18nKeys } from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import { TKhattabatFeatureBadge } from "../../../../Types";

const KhattabatUserFeatureRow = withLiteObserverAndTheme<{
  labelKey: Ti18nKeys;
  badges: TKhattabatFeatureBadge[];
  inactiveColor: string;
}>(({ labelKey, badges, inactiveColor }) => (
  <Stack
    direction="row"
    spacing={1}
    alignItems="center"
    flexWrap="wrap"
    useFlexGap
  >
    <Typography fontWeight={fontWeights.semibold} sx={{ minWidth: 220 }}>
      {i18n.get(labelKey)}
    </Typography>
    {badges
      .filter((badge) => badge.isPaid)
      .map((badge) => (
        <Chip
          key={badge.tagKey}
          size="small"
          label={i18n.get(badge.tagKey)}
          sx={{
            bgcolor: badge.isSubscribed ? badge.color : inactiveColor,
            color: "common.white",
            fontWeight: fontWeights.bold
          }}
        />
      ))}
  </Stack>
));

export default KhattabatUserFeatureRow;
